import styled from "styled-components";

import { media } from "../../../../styles/media";

export const ChangePasswordFormStyles = styled.div`
  .inputContainer {
    width: 48%;
  }

  .bottomInputs {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
  }

  ${media.maxMobile`
    .bottomInputs {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
    .inputContainer {
      width: 100%;
    }
  `}
`;
